<template>
	<v-list density="compact">
		<v-list-item class="list-ChartContextMenu" v-for="(item, index) in itemsForRoadEdit" :key="index"
			@click="onCMClickForRoadSegmentEdit($event, item.id)">
			<v-list-item-title>
				{{ $t(item.title) }}
			</v-list-item-title>
		</v-list-item>
	</v-list>
</template>

<script lang="ts">
import * as constant from "@/constant";
import { HorizontalAlignmentType } from "earthbrain-viewer";
import { useStore } from "vuex";

export default {
	setup() {
		const store = useStore();
		return {
			store,
		};
	},
	props: {
		pathId: String,
		point: Array,
	},

	data: () => ({
		itemsForRoadEdit: [
			{ id: 1, title: "ADD" },
			{ id: 2, title: "TangentAlignment" },
			{ id: 3, title: "SimpleCurveAlignment" },
			// { id: 4, title: "SpiralTransitionedAlignment" },
			{ id: 5, title: "Undo" },
			{ id: 6, title: "Redo" },
		],
	}),
	methods: {
		onCMClickForRoadSegmentEdit(e, id) {
			e.preventDefault();
			switch (id) {
				case 1:
					this.store.getters.viewer.addControlPointOnCenterLineOfRoad(
						this.pathId,
						this.point,
					);
					break;
				case 2:
					this.updateHorizontalAlignmentType(HorizontalAlignmentType.TANGENT);
					break;
				case 3:
					this.updateHorizontalAlignmentType(
						HorizontalAlignmentType.SIMPLE_CIRCULAR,
					);
					break;
				case 4:
					this.updateHorizontalAlignmentType(
						HorizontalAlignmentType.SPIRAL_TRANSITIONED,
					);
					break;
				case 5:
					this.store.getters.viewer.undo();
					break;
				case 6:
					this.store.getters.viewer.redo();
					break;
			}
		},
		updateHorizontalAlignmentType(type) {
			this.store.getters.viewer.updateRoadHorizontalAlignmentType(
				this.pathId,
				type,
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.list-ChartContextMenu:hover {
	background-color: #0064ba !important;
}
</style>
